// extracted by mini-css-extract-plugin
export default {"navigationMenu":"NavigationMenu_navigationMenu__7PN8y"};